import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Header = styled.header`
  position: relative;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.surface};
  /* Same rounding as the Sidebar shell card. */
  border-radius: 16px;
  z-index: 2;
  flex-shrink: 0;
  padding: 0 20px;
  box-sizing: border-box;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding: 0 10px 0 20px;
    /* Full-bleed flat bar on mobile — the card treatment is desktop-only. */
    border-radius: 0;
  }
`

export const LeftBlock = styled.div`
  display: flex;
  align-items: center;
`

export const RightBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const Separator = styled.div<{ $hideOnMobile?: boolean }>`
  width: 1px;
  height: 20px;
  background-color: ${COLORS.border};
  margin: 0 16px;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    display: ${({ $hideOnMobile }) => ($hideOnMobile ? 'none' : 'block')};
    margin: 0 10px;
  }
`
